exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".loading-indicator-component[data-v-727adc67]{text-align:center}", ""]);

